import { NgClass } from '@angular/common';
import { Component, computed, inject, input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { of } from 'rxjs';
import { HashMap, LocalizationService } from '@capital-access/common/localization';
import { IconSize } from '@capital-access/common/utils';
import { FireflyPopoverModule } from '@capital-access/firefly/components';
import { COMMON_COMPONENTS_LOCALIZATION_SCOPE } from '../common-components.const';
import {
  EsgDataPointFields,
  ESGDataPointLocalization,
  ESGDataPointLocalizationKeys,
  EsgDataPointTitle
} from './models/ca-esg-popover-enum';

@Component({
  selector: 'ca-esg-popover',
  standalone: true,
  imports: [NgClass, FireflyPopoverModule],
  templateUrl: './esg-popover.component.html'
})
export class EsgPopoverComponent {
  title = input.required<EsgDataPointTitle>();
  showTitle = input<boolean>(true);
  iconSize = input<IconSize>(IconSize.Sm);

  readonly localizationService = toSignal(
    inject(LocalizationService, { optional: true })?.getLocalization(COMMON_COMPONENTS_LOCALIZATION_SCOPE) ??
      of({} as HashMap),
    { initialValue: {} as HashMap }
  );

  readonly localizedTitle = computed(() => this.getInfo(this.title(), 'title'));

  readonly mainInfo = computed(() => this.getInfo(this.title(), 'primaryInfo'));

  readonly infoSecondaryDescription = computed(() => this.getInfo(this.title(), 'secondaryInfo'));

  readonly fullTitle = computed(() => this.getInfo(this.title(), 'fullTitle'));

  readonly titleArticle6 = computed(() => this.getInfo(this.title(), 'article6Title'));

  readonly infoArticle6 = computed(() => this.getInfo(this.title(), 'article6Info'));

  readonly titleArticle8 = computed(() => this.getInfo(this.title(), 'article8Title'));

  readonly infoArticle8 = computed(() => this.getInfo(this.title(), 'article8Info'));

  readonly titleArticle9 = computed(() => this.getInfo(this.title(), 'article9Title'));

  readonly infoArticle9 = computed(() => this.getInfo(this.title(), 'article9Info'));

  private getInfo(datapoint: EsgDataPointTitle, infoType: keyof EsgDataPointFields): string {
    return (
      this.localizationService()[ESGDataPointLocalizationKeys[datapoint]?.[infoType] || ''] ||
      ESGDataPointLocalization[datapoint]?.[infoType]
    );
  }
}
